import axios from 'axios';
import { REST_API } from '../constants/defaultValues';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: REST_API,
  withCredentials: true
});

// Alikhtayar desktop only: attach SEFI device proof (signed in Electron main;
// private key never in the renderer). Signature binds method, path+query and the
// SHA-256 of the canonical JSON body. Web builds have no window.desktop -> no-op.
const canonicalBody = (data) => {
  let v = data;
  if (typeof v === 'string') {
    try { v = JSON.parse(v); } catch (e) { return v; }
  }
  if (v == null) return '';
  if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return '';
  return JSON.stringify(v);
};

const sha256Hex = async (text) => {
  const buf = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
};

axiosInstance.interceptors.request.use(async (config) => {
  const signer = typeof window !== 'undefined' && window.desktop && window.desktop.license;
  if (!signer) return config;
  const uri = axiosInstance.getUri(config).replace(/^[a-z]+:\/\/[^/]+/i, '');
  const i = uri.indexOf('/api/sefi/');
  if (i < 0) return config;
  try {
    const bodySha256 = await sha256Hex(canonicalBody(config.data));
    const proof = await signer.sign((config.method || 'get').toUpperCase(), uri.slice(i), bodySha256);
    config.headers = { ...config.headers, 'X-Sefi-Device': proof };
  } catch (e) {
    // unsigned request -> server applies web policy / rejects; never blocks non-SEFI calls
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
